<template>
  <div v-if="api_data.Farmer">
    <div v-if="operation_mode == 'write'">
      <div class="form-group">
        <label>{{ $t(form_label) || 'N/A' }}
          <br>
          {{ file_input_name }}
        </label>
        <input :class="'form-control ' + form_class"
               :name="file_input_name"
               v-model="api_data.Farmer[file_input_name]"
               :placeholder="form_label || 'N/A' ">
      </div>
    </div>
    <div v-if="operation_mode == 'read'">
      <label-text
          v-if="api_data.Farmer[file_input_name]"
          v-bind:text="api_data.Farmer[file_input_name]"
          v-bind:label="form_label"
      ></label-text>
    </div>
  </div>
</template>
<script>
export default {
  name: 'text-input',
  props: {
    form_label: String,
    form_class: String,
    file_input_name: {
      type: String,
      default: function () {
        return ''
      }
    },
    api_data: {
      type: Object,
      default: function () {
        return {}
      },
    },
    operation_mode: {
      type: String,
      default: function () {
        return 'write'
      }
    }
  }
}
</script>
